import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { MANUAL_VIEW_BASE } from "./ProductDocsSection";

const API_BASE_URL = "https://www.lankastudio.cn/api";

/**
 * 官网说明书浏览页：嵌入效率中心公开浏览视图（支持导出 PDF）
 */
export default function ManualViewerPage() {
  const { id } = useParams();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");

  const iframeSrc = useMemo(() => {
    if (!id) return "";
    return `${MANUAL_VIEW_BASE}/${id}`;
  }, [id]);

  useEffect(() => {
    if (!id) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/manuals/${id}`);
        if (!res.ok) throw new Error("说明书不存在");
        const data = await res.json();
        if (!cancelled) setMeta(data);
      } catch (err) {
        if (!cancelled) setError(err.message || "加载失败");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  const title =
    meta?.title?.chineseName || meta?.title?.englishName || (id ? `说明书 #${id}` : "说明书");

  const productId = meta?.bunding_product_id ?? meta?.bundingProductID;

  return (
    <div style={styles.page}>
      <div style={styles.topBar}>
        <div style={{ minWidth: 0 }}>
          <div style={styles.title}>{title}</div>
          {meta?.title?.englishName && meta?.title?.chineseName ? (
            <div style={styles.sub}>{meta.title.englishName}</div>
          ) : null}
        </div>
        <div style={styles.actions}>
          {productId > 0 ? (
            <Link to={`/products/${productId}`} style={styles.linkBtn}>
              返回产品
            </Link>
          ) : (
            <Link to="/products" style={styles.linkBtn}>
              产品列表
            </Link>
          )}
          <a
            href={iframeSrc}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.linkBtn}
          >
            新窗口打开
          </a>
          <a
            href={`${iframeSrc}?export=1`}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.primaryBtn}
          >
            导出 PDF
          </a>
        </div>
      </div>

      {error ? (
        <div style={styles.error}>{error}</div>
      ) : (
        <iframe title={title} src={iframeSrc} style={styles.iframe} />
      )}
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#1a1510",
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "10px 14px",
    background: "#2b2118",
    borderBottom: "1px solid rgba(255,255,255,0.08)",
    flexWrap: "wrap",
  },
  title: {
    color: "#f3e6d4",
    fontWeight: 800,
    fontSize: 15,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  sub: {
    color: "rgba(243,230,212,0.65)",
    fontSize: 12,
    marginTop: 2,
  },
  actions: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  linkBtn: {
    padding: "7px 12px",
    borderRadius: 8,
    border: "1px solid rgba(243,230,212,0.25)",
    color: "#f3e6d4",
    textDecoration: "none",
    fontSize: 12,
    fontWeight: 700,
  },
  primaryBtn: {
    padding: "7px 12px",
    borderRadius: 8,
    border: "none",
    background: "#c4a574",
    color: "#1a1510",
    textDecoration: "none",
    fontSize: 12,
    fontWeight: 800,
  },
  iframe: {
    flex: 1,
    width: "100%",
    minHeight: "calc(100vh - 58px)",
    border: "none",
    background: "#e8dfd2",
  },
  error: {
    padding: 40,
    textAlign: "center",
    color: "#fca5a5",
  },
};
